const Seconds_Per_Minute = 60;

export const secondsToMinutes = (seconds: number): number => {
  return seconds / Seconds_Per_Minute;
};

export const minutesToSeconds = (minutes: number): number => {
  return minutes * Seconds_Per_Minute;
};
